import {BASE_API_URL} from '@env';
import {useMutation} from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';

export const useDeleteBusiness = () => {
  const mutation = useMutation(async (business_id: string) => {
    const token = useUserStore.getState().token;
    const response = await fetch(`${BASE_API_URL}businesses/${business_id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to delete user');
    }
  });

  return mutation;
};
